module.exports = __webpack_public_path__ + "static/media/LOGO SISPROIND 200.6bce9d45.png";